import { Collection } from 'modules/core/lib/mobx-rest'

import Application from 'modules/ats/store/models/Application'

export interface BulkUpdateParams {
  ids: number[]
  ats_application_phase_id?: number
  qualified?: true
}

export interface BulkDisqualifyParams {
  ids: number[]
  disqualified_reason: string
  disqualified_message?: string
  notify?: boolean
  send_as_corporate_email?: boolean
  talent_pool?: boolean
}

class Applications extends Collection<Application> {
  get indexes() {
    return ['ats_candidate_id', 'ats_application_phase_id', 'ats_job_posting_id']
  }

  model() {
    return Application
  }

  bulkUpdate(data: BulkUpdateParams) {
    return this.rpc('bulk_update', data)
  }

  bulkDisqualify(data: BulkDisqualifyParams) {
    return this.rpc('bulk_disqualify', data)
  }
}

const singleton: Applications = new Applications()

export default singleton
